export default function PageContainer({ children, testid = "page-container", wide = false }) {
  return (
    <div
      className={`px-6 md:px-10 lg:px-14 xl:px-16 py-10 md:py-14 ${wide ? "max-w-[1400px]" : "max-w-[1160px]"}`}
      data-testid={testid}
    >
      {children}
    </div>
  );
}

export function PageHeader({ overline, title, subtitle, testid = "page-header", actions }) {
  return (
    <header className="mb-10 fade-up" data-testid={testid}>
      {overline && <div className="overline mb-3">{overline}</div>}
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <h1 className="text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tightest font-semibold max-w-3xl">
          {title}
        </h1>
        {actions && <div className="flex-shrink-0">{actions}</div>}
      </div>
      {subtitle && (
        <p className="mt-4 text-base md:text-lg text-ink-muted max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      )}
    </header>
  );
}
